export const settings = {
  REJECTED_POSTAL_TYPES: ['PO BOX', 'CARE PO'],
};
